export async function copyToClipboard(textToCopy) {
  // Navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(textToCopy);
  } else {
    const focusedElement = document.activeElement;

    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;

    textArea.style.position = 'absolute';
    textArea.style.opacity = '0';
    textArea.style.height = '0';
    textArea.style.width = '0';
    if (focusedElement) {
      focusedElement.appendChild(textArea);
    } else {
      document.body.appendChild(textArea);
    }
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error(err);
    } finally {
      if (focusedElement) {
        focusedElement.removeChild(textArea);
      } else {
        document.body.removeChild(textArea);
      }
    }
  }
}
